import { Component, createRef } from 'react'
import Measurements from '~/utils/Measurements'
import styles from '~/styles/ordersPage.package.module.css'
import types from '~/types/ordersPage.ts'

export default class SomeOrderProperties extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders' ],
		}
	}
	
	constructor(props) {
		super(props)
		this.state = {}
		this._initPackages()
		this._getPackages()
		if (this.props.setPackageInit) {
			this.props.setPackageInit(this._setPackage.bind(this))
		}
		this._defaultPackageCode = 'Package'
		this._defaultPackageName = this._packages?.defaultDealerPackage?.[this._defaultPackageCode]?.package_name
	}
	
	render(): JSX.Element {
		const options = this._getSelectOptions()
		let value = this._suitablePackage?.package_name
		if (!value) {
			value = this.state.packageName || this._defaultPackageName
		}
		let code = this._suitablePackage?.package_code
		if (!code) {
			code = this.state.packageCode || this._defaultPackageCode
		}
		return (
			<>
				<label>
					{this.props.t('Package Name')}
				</label>
				<div>
					<select
						value={value}
						code={code}
						onChange={this._onChange.bind(this)}
					>
						{options}
					</select>
				</div>
			</>
		)
	}

	componentDidMount() {
		if (!this.state.packageName && this._defaultPackageName) {
			this.setState({ packageName: this._defaultPackageName })
			if (this.props.setPackageCost) {
				let data = this._packages?.[this._packageType]?.[this._defaultPackageCode] || {}
				this.props.setPackageCost(data?.price || 0)
			}
		}
	}

	private _onChange(event, packageCode) {
		let packageName = event?.target?.value
		if (!packageCode) {
			const selectedIndex = event.target?.options?.selectedIndex
			packageCode = event.target?.options[selectedIndex]?.getAttribute('code')
			this.props.removeCalculatedPackageCode()
			this._setPackage(packageCode)
		} else {
			packageName = this._packages?.[this._packageType]?.[packageCode]?.package_name
			if (!packageName) {
				packageName = this.props.t('Package')
			}
		}
		this.setState({ packageName, packageCode })
		if (this.props.editTheOrder) {
			let data = this._packages?.[this._packageType]?.[packageCode] || {}
			let objectToSet = {}
			const currentPackage = this.props.order.packageObject
			if (currentPackage?.package_code !== packageCode) {
				let packageObject = this?._packages?.[this._packageType]?.[packageCode]
				if (packageCode === 'Package') {
					packageObject = null
				}
				objectToSet['packageObject'] = packageObject
			}
			const dimensionalMU = this.props.order.dealer_dimensions_mu
			const weightMU = this.props.order.dealer_weight_mu
			const measurements = new Measurements(dimensionalMU, weightMU)
			let length = 0
			let width = 0
			let height = 0
			if (event) {
				length = measurements.muToMu(+data.length, data.dimension_mu)
				if (length && length !== this.props.order['mu_in_length']) {
					objectToSet['mu_in_length'] = length
				}
				width =  measurements.muToMu(+data.width, data.dimension_mu)
				if (width && width !== this.props.order['mu_in_width']) {
					objectToSet['mu_in_width'] = width
				}
				height = measurements.muToMu(+data.height, data.dimension_mu)
				if (height && height !== this.props.order['mu_in_height']) {
					objectToSet['mu_in_height'] = height
				}
			}
			let weight = 0
				weight = measurements.muToMu(+data.weight, data.weight_mu, true)
			if (weight) {
				objectToSet['mu_in_weight'] = weight
			}
			this.props.editTheOrder(objectToSet)
			if (event) {
				if (this.props.inputSetter) {
					length && this.props.inputSetter['in_length'](length)
					width && this.props.inputSetter['in_width'](width)
					height && this.props.inputSetter['in_height'](height)
					weight && this.props.inputSetter['in_weight'](weight)
				}
			}
			if (this.props.setPackageCost) {
				this.props.setPackageCost(data?.price || 0)
			}
			if (event) {
				setTimeout(() => {
					this.props?.refreshPointPrice(packageCode === 'Package' ? '_customPackage' : packageCode)
				})
			}
		}
	}

	private _getItemsWeightKg(): number {
		let itemsWeightKg = 0
		const items = this.props.order?.orderItems
		if (items) {
			Object.keys(items).forEach(itemId => {
				const item = items[itemId]
				if (!item.isDefautItem) {
					itemsWeightKg += (item['Item Weight'] * item['Quantity']) / 1000
				}
			})
		}
		return +(itemsWeightKg || 0)
	}

	private _getPackages() {
		if (this.props.order?.packages) {
			let packagesObject = {}
			let maxSortingOrder = 0
			this.props.order.packages.forEach(packageObject => {
				const packageCode = packageObject?.package_code
				if (packageCode) {
					packagesObject[packageObject?.package_code] = packageObject
					if (maxSortingOrder < packageObject.sorting_order) {
						maxSortingOrder = packageObject.sorting_order
					}
				}
			})
			packagesObject['Package'] = {
				package_name: this.props.t('Package'),
				package_price: 0,
				sorting_order: maxSortingOrder + 1,
			}
			this._packages['dealerPackages'] = packagesObject
		}
	}	

	private _getDimension(valueMM, dimension_mu) {
		let dimension = 0
		if (dimension_mu === 'in') {
			dimension = valueMM / 25.4
		} else {
			dimension = valueMM / 10
		}
		return dimension
	}

	private _getRounded(value) {
		return Math.round(value * 10000) / 10000
	}

	private _getDimensionMM(value, dimension_mu) {
		let dimensionMM = 0
		if (dimension_mu === 'in') {
			dimensionMM = value * 25.4
		} else {
			dimensionMM = value * 10
		}
		return dimensionMM
	}

	private _getRoundWeight(valueKg, weight_mu) {
		let weight = 0
		if (weight_mu === 'lb') {
			weight = Math.round(valueKg * 2.20462262185 * 10) /10
		} else {
			weight = Math.round(valueKg * 1000)
		}
		return weight
	}

	private _getWeightKg(value, weight_mu) {
		let weight = 0
		if (weight_mu === 'lb') {
			weight = value / 2.20462262185
		} else {
			weight = +(value || 0)
		}
		return weight
	}

	private _getSelectOptions() {
		let packages = Object.assign({}, this._packages.defaultDealerPackage)
		this._packageType = 'defaultDealerPackage'
		if (this._packages['dealerPackages']) {
			this._packageType = 'dealerPackages'
			packages = Object.assign({}, this._packages[this._packageType])
			const dimensionalMU = this.props.order.dealer_dimensions_mu
			const weightMU = this.props.order.dealer_weight_mu
			const measurements = new Measurements(dimensionalMU, weightMU)
			const suitablePackage = this._getSuitablePackage(packages, measurements)
			if (!suitablePackage) {
				packages['Package'] = this._packages.defaultDealerPackage.Package
				this._suitablePackage = 'Package'
			} else {
				this._suitablePackage = suitablePackage
			}
		} else {
			this._suitablePackage = 'Package'
		}
		let options = []
		Object.keys(packages).sort((a, b) => {
			return packages[a].order - packages[b].order
		}).forEach((packageCode, i) => {
			const packageObject = packages[packageCode]
			const packageName = packageObject.package_name
			options.push((
				<option 
					key={packageCode}
					code={packageCode}
				>
					{packageName}
				</option>
			))
		})
		return options
	}

	private _getSuitablePackage(packages, measurements) {
		let suitablePackage = null
		if (packages) {
			Object.keys(packages).forEach(packageCode => {
				const packageObject = packages[packageCode]
				const packageLength = measurements.muToMu(packageObject.length, packageObject.dimension_mu)
				const packageWidth = measurements.muToMu(packageObject.width, packageObject.dimension_mu)
				const packageHeight = measurements.muToMu(packageObject.height, packageObject.dimension_mu)
				const isEqualLength = (this._getRounded(packageLength) === this._getRounded(this.props.order.mu_in_length))
				const isEqualWidth = (this._getRounded(packageWidth) === this._getRounded(this.props.order.mu_in_width))
				const isEqualHeight = (this._getRounded(packageHeight) === this._getRounded(this.props.order.mu_in_height))
				if (isEqualLength && isEqualWidth && isEqualHeight) {
					// suitablePackage = packageObject
				}
			})
		}
		// if (this.props.editTheOrder) {
		// 	const currentPackage = this.props.order.packageObject
		// 	const currentPackageId = currentPackage ? currentPackage?.package_code + currentPackage.package_name : ''
		// 	const newPackage = packages?.[suitablePackage?.package_code]
		// 	const newPackageId = newPackage ? newPackage?.package_code + newPackage.package_name : ''
		// 	if (currentPackageId !== newPackageId) {
		// 		setTimeout(() => {
	 // 				this.props.editTheOrder({ packageObject: newPackage })
	 // 			})
		// 	}
		// }
		return suitablePackage
	}

	private _setPackage(packageCode: string): void {
		if (!packageCode) {
			packageCode = 'Package'
		}
		if (packageCode && this.state.packageCode !== 'Package') {
			if (this.props.editTheOrder) {
				
			}
			this._onChange(null, packageCode)
		}
	}

	private _initPackages() {
		this._packages = {
			'defaultDealerPackage': {
				'Package': {
					package_name: this.props.t('Package'),
					length: this.props.order.defaultPackageLengthMu,
					width: this.props.order.defaultPackageWidthMu,
					height: this.props.order.defaultPackageHeightMu,
					weight: this.props.order.defaultPackageWeightMu,
					order: 0,
					price: 0,
					dimension_mu: this.props.order.dealer_dimensions_mu,
					weight_mu: this.props.order.dealer_weight_mu,
				},
			},
		}

	}
}